// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".validation-check[data-v-8bdbed14]{position:absolute;top:50%;right:1rem;transform:translateY(-50%)}\n", ""]);
// Exports
module.exports = exports;
